import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardBody } from 'reactstrap';
import API from '../../api';
import { Table, rangeLabel } from './business';
import { selection } from './business-model';
import './business.css';

const n = value => Number(value).toLocaleString('fa-IR');
export default function TehranReport({ location }) {
    const { type, key } = selection(location.search);
    const allowed = (localStorage.getItem('user_can') || '').split(',').includes('manage-business-reports');
    const [report, setReport] = useState(null), [loading, setLoading] = useState(true), [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        if (!allowed) { setLoading(false); return () => { active = false; }; }
        if (!key) { setLoading(false); setError('دوره گزارش مشخص نشده است.'); return () => { active = false; }; }
        setLoading(true); setError('');
        API.post('reports/business', { type, key }).then(data => {
            if (!active) return;
            if (!data?.report || data.ERRORS?.length) throw new Error(data?.ERRORS?.join(' ') || 'گزارش دریافت نشد.');
            setReport(data.report); setLoading(false);
        }).catch(e => { if (active) { setError(e.response?.data?.data?.ERRORS?.join(' ') || e.message); setLoading(false); } });
        return () => { active = false; };
    }, [allowed, type, key]);
    if (!allowed) return <Alert color="warning">دسترسی گزارش‌های مدیریتی ندارید.</Alert>;
    const rows = report?.data?.tehranZones;
    const count = (rows || []).reduce((sum, r) => sum + r.count, 0);
    const value = (rows || []).reduce((sum, r) => sum + r.value, 0);
    return <div className="invoice business-reports"><Card><CardBody>
        <header className="business-heading"><h1><i className="simple-icon-location-pin" /> محدوده‌های تهران</h1><span>{rangeLabel(report)}</span></header>
        <div className="business-detail-toolbar print-hide" style={{ justifyContent: 'flex-end' }}><Button outline color="primary" className="rounded-0" disabled={loading || !!error || !rows} onClick={() => window.print()}><i className="simple-icon-printer" /> چاپ گزارش</Button></div>
        <div className="business-tab-content">
            {loading ? <p role="status">در حال دریافت گزارش…</p> : error ? <Alert color="warning">{error}</Alert> : !rows ? <Alert color="info">ریز محدوده‌ها هنوز محاسبه نشده است.</Alert> : <Table headers={['محدوده', 'سفارش', 'سهم', 'ارزش سفارش‌ها (تومان)']} rows={rows.map(r => [r.name, n(r.count), count ? `${n(Math.round(r.count / count * 1000) / 10)}٪` : '—', n(r.value)])} total={['جمع تهران', n(count), count ? '۱۰۰٪' : '—', n(value)]} />}
        </div>
    </CardBody></Card></div>;
}
